import React from "react";

const CheckSmallIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13.446" height="12.008" viewBox="0 0 8.446 7.008">
    <path id="Caminho_2340" data-name="Caminho 2340" d="M-6316.687,3789.92l2.061,2.552,1.887-1.849,3.021-2.96" transform="translate(6317.465 -3786.948)" fill="none" stroke="#50b436" strokeWidth="2"/>
  </svg>
);

export default CheckSmallIcon;
